import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import SEO from '../components/SEO';
import Layout from '../layouts/index';
import { DemoFormLong } from '../components/DemoFormLong.jsx';
import HtmlParser from 'html-react-parser';
import MultimedialPanel from '../components/MultimedialPanel'
import Modal from '../components/Modal'
import { DemoFormModal } from '../components/DemoFormModal.jsx';
import JoinHappyCustomers from '../components/JoinHappyCustomers';
import UserTestimonyCard from '../components/cards/UserTestimonyCard';
import '../scss/pages/_pricing-v2.scss';

const Pricing = (props) => {

    const location = props.location;
    const [modalVisible, setModalVisible] = useState(false);
    const [formPressed, setFormPressed] = useState({buttonText:"",buttonColor:"",source:""});
    const [stickyTableState, setStickyTableState] = useState('');

    const showModal = (data) => {
        setFormPressed(data);
        setModalVisible(true);
        
    };

    const hideModal = () => {
        setModalVisible(false);
    };

    const FormPopUp = ({source}) => {
        return(
            <Modal show={modalVisible} handleClose={hideModal}>
                <section name="request-demo-white" id="request-demo-popup" className="modal-border-radius request-with-us-modal sectionSpacing">
                    <DemoFormModal buttonText={formPressed.buttonText} buttonColor={formPressed.buttonColor} source={source}/>
                </section>
            </Modal>
        )
    };

    useEffect(() => {
    
        function add_class_on_scroll() {
            setStickyTableState('stickyTable')
        }
    
        function remove_class_on_scroll() {
            setStickyTableState('')
        }

        function scrollEventHandler () {

            let scrollpos = window.scrollY;

            if (scrollpos > 740) {
                add_class_on_scroll();
            } else {
                remove_class_on_scroll();
            }

        }
    
        window.addEventListener('scroll', scrollEventHandler);
        
        return () => window.removeEventListener('scroll', scrollEventHandler);

    }, [])
    

    return (
        <Layout  bodyClass="page-pricing" ontouchstart>
            <SEO title="Pricing | ChartHop | People Analytics, Visualized" />
            <Helmet>
                <meta
                    name="description"
                    content="The best org chart now comes with DE&I Reporting, people analytics, workforce and compensation planning, and so much more. It's time for an upgrade."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Pricing | ChartHop | People Analytics, Visualized" />
                <meta property="og:description" content="The best org chart now comes with DE&I Reporting, people analytics, workforce and compensation planning, and so much more. It's time for an upgrade." />
                <meta property="og:image" content={`https://www.charthop.com/home/visualized.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Pricing | ChartHop | People Analytics, Visualized" />
                <meta name="twitter:description" content="The best org chart now comes with DE&I Reporting, people analytics, workforce and compensation planning, and so much more. It's time for an upgrade." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/visualized.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />     

            </Helmet>
             {/* HERO CONTENT */}
             <section className="sectionSpacing hero">
                <div className="contentBlock">
                    <MultimedialPanel 
                        type="image"
                        link="/img/hero_image.png"
                        alt="hero"
                        styleClass="heroPricingImage"
                        paddingClass="padding-top-video"
                        multimediaPosition="right"
                        title=""
                        content={
                            <React.Fragment>
                            <h1 className="pricing-hero-title">The people analytics platform that scales with you.</h1>
                            </React.Fragment>
                        }
                    />
                </div>
            </section>

            <FormPopUp source={formPressed.source} />

            {/* MIDDLE BOXES SECTION*/}

            <section className="backgroundGradientContainer sectionSpacing flex-centeredColumn pricingTable">
                <div className="container">
                    <div class="row">
                        <div class={"col " + stickyTableState} id="compare-table">
                            <div class="compare-row pricingTable-header">
                                <div class="header-container">
                                    <div class="compare-col features">FEATURES</div>
                                    <div class="compare-col">
                                        <div className="pricingTable-card build">                                        
                                            <h4 className="pricingTable-title">ChartHop<br></br>Build</h4>
                                            <p className="pricingTable-description">Build the foundation your team needs to succeed.</p>                                        
                                            <p className="pricingTable-price">$3.50</p>
                                            <p className="pricingTable-disclamer">per employee* per month<br></br>(billed annually)</p>
                                            <div className="button-box">
                                                <a className="button button-build" id="charthop-build-btn" rel="noopener noreferrer" onClick={() => showModal({buttonText:"BUILD WITH US",buttonColor:"#36ACE0",source:"pricing-build-chatwithus"})} >BUILD<span className="hideMin1060"><br></br></span> WITH US</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="compare-col">
                                        <div className="pricingTable-card grow">                                        
                                            <h4 className="pricingTable-title">ChartHop<br></br>Grow</h4>
                                            <p className="pricingTable-description">Leverage systems and data to grow intentionally.</p>                                       
                                            <p className="pricingTable-price">$7</p>
                                            <p className="pricingTable-disclamer">per employee* per month<br></br>(billed annually)</p>
                                            <div className="button-box"><a className="button button-grow" id="charthop-grow-btn" rel="noopener noreferrer" onClick={() => showModal({buttonText:"GROW WITH US",buttonColor:"#2688BF",source:"pricing-grow-chatwithus"})}>GROW<span className="hideMin1060"><br></br></span> WITH US</a></div>
                                        </div>
                                    </div>
                                    <div class="compare-col">
                                        <div className="pricingTable-card scale">                                        
                                            <h4 className="pricingTable-title">ChartHop<br></br>Scale</h4>
                                            <p className="pricingTable-description">Empower all leaders and employees with the workflows and data needed to scale.</p>                                        
                                            <p className="pricingTable-price">$10</p>
                                            <p className="pricingTable-disclamer">per employee* per month<br></br>(billed annually)</p>
                                            <div className="button-box"><a className="button button-scale" id="charthop-scale-btn" rel="noopener noreferrer" onClick={() => showModal({buttonText:"SCALE WITH US",buttonColor:"#006699",source:"pricing-scale-chatwithus"})}>SCALE<span className="hideMin1060"><br></br></span> WITH US</a></div>
                                        </div>
                                    </div>
                                    <div class="compare-col">
                                        <div className="pricingTable-card enterprise"> 
                                            <h4 className="pricingTable-title">ChartHop<br></br>Enterprise</h4>
                                            <p className="pricingTable-description">Provide the data and process your teams need to be more agile and efficient.</p>
                                            <p className="pricingTable-custom">Custom Pricing</p>
                                            <div className="button-box"><a className="button button-enterprise" id="charthop-enterprise-btn" rel="noopener noreferrer" onClick={() => showModal({buttonText:"CONTACT US",buttonColor:"#295277",source:"pricing-enterprise-chatwithus"})}>CONTACT<span className="hideMin1060"><br></br></span> US</a></div>                                  
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    Live Org Chart
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>All Org Access with Employee Profiles</span>
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>Diversity, Equity and Inclusion Reports</span>
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div> 
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>HRIS, Slack and Carta Integrations</span>
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>Employee Engagement Surveys</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>Robust Reporting</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div> 
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>Custom Data</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>Performance Reviews</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>Headcount Planning</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>ATS Integration</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>Custom Exports** (PPT, Comp Letters, etc.)</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>Personalized Support</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row">
                                <div class="compare-col">
                                    <span>Custom Integrations</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>
                            <div class="compare-row last-item">
                                <div class="compare-col">
                                    <span>Workflow consulting & design</span>
                                </div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col"></div>
                                <div class="compare-col">
                                    <img className="check-table-desktop" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                </div>
                            </div>                         
                        </div>
                    </div>
                </div>

                {/* PLUS DESKTOP */}
                <div className="container">
                    <div className={(stickyTableState && "marginNoScroll") + " lastSection"}>
                    <div className="row">
                        <div className="col">
                            <div>
                                <h4>Compensation Planning</h4>                            
                                <div className="first-section">
                                    <p className="price">+$2</p>
                                    <p className="disclamer">per employee* per month<br></br>(billed annually) + additional service fees</p>
                                </div>  
                            </div>                          
                        </div>   
                        <div className="col check">
                            <div>
                                          
                                <p>Consolidated data</p>
                            </div>                            
                        </div>
                        <div className="col check">
                            <div>     
                                                          
                                <p>Streamlined distribution</p>
                            </div>
                        </div>
                        <div className="col check">
                            <div>
                           
                                <p>Robust analytics</p>
                            </div>
                        </div>
                        <div className="col button-price">
                            <a className="button button-withCharthop button-enterprise" rel="noopener noreferrer" onClick={() => showModal({buttonText:"CONTACT US",buttonColor:"#36ACE0",source:"pricing-performance-chatwithus"})}>CONTACT US</a>
                        </div>
                    </div>
                    
                </div>
                <div className="extra-feature-text">
                    <span>*for every employee in your organization, annual agreements start at $9,600</span>
                </div>
                <div className="extra-feature-text">
                    <span>**custom branded exports available for an additional fee</span>
                </div>
                </div>
                
            </section>


            {/* PRICING CARDS MOBILE */}
            <section className="backgroundGradientContainer sectionSpacing flex-centeredColumn pricingCards">                
                <div className="floating-majorCardBoxContainer pt-3 pb-3"> 

                    {/* BUILD MOBILE */}
                    <div className="container">
                        {/*header*/}
                        <h4 className="build">ChartHop Build</h4>
                        <p className="description">Build the foundation your team needs to succeed.</p>
                        <div className="first-section">
                            <p className="price build">$3.50</p>
                            <p className="disclamer">per employee* per month<br></br>(billed annually)</p>
                        </div>
                        <hr></hr>
                        {/*bullets*/}
                        <div className="content">
                            <div className="pgc1">
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                        <p>Live Org Chart</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/build-check.svg'}alt="checkmark" />
                                        <p>All Org Access with Employee Profiles </p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/build-check.svg'}alt="checkmark" />
                                        <p>Diversity, Equity and Inclusion Reports</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/build-check.svg'}alt="checkmark" />
                                        <p>HRIS, Slack and Carta Integrations</p>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        {/*button section*/}                        
                        <a className="button button-withCharthop button-build" id="charthop-build-btn" rel="noopener noreferrer" onClick={() => showModal({buttonText:"BUILD WITH US",buttonColor:"#36ACE0",source:"pricing-build-chatwithus"})} >BUILD WITH US</a>                               
                    </div>

                    {/* GROW MOBILE */}
                    <div className="container">
                        {/*header*/}
                        <h4 className="grow">ChartHop Grow</h4>
                        <p className="description">Leverage systems and data to grow intentionally.</p>
                        <div className="first-section">
                            <p className="price grow">$7</p>
                            <p className="disclamer">per employee* per month<br></br>(billed annually)</p>
                        </div>
                        <hr></hr>
                        {/*bullets*/}
                        <div className="content">
                            <div className="pgc1">
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/grow-check.svg'} alt="checkmark" />
                                        <p>Everything in <strong className="build">ChartHop Build</strong></p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/grow-check.svg'} alt="checkmark" />
                                        <p>Employee Engagement Surveys </p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/grow-check.svg'} alt="checkmark" />
                                        <p>Robust Reporting</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/grow-check.svg'}alt="checkmark" />
                                        <p>Custom Data</p>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        {/*button section*/}
                        <a className="button button-withCharthop button-grow" id="charthop-grow-btn" rel="noopener noreferrer" onClick={() => showModal({buttonText:"GROW WITH US",buttonColor:"#2688BF",source:"pricing-grow-chatwithus"})}>GROW WITH US</a>
                    </div>

                    {/* SCALE MOBILE */}
                    <div className="container">
                        {/*header*/}
                        <h4 className="scale">ChartHop Scale</h4>
                        <p className="description">Empower all leaders and employees with the workflows and data needed to scale.</p>
                        <div className="first-section">
                            <p className="price scale">$10</p>
                            <p className="disclamer">per employee* per month<br></br>(billed annually)</p>
                        </div>
                        <hr></hr>                        
                        {/*bullets*/}
                        <div className="content">
                            <div className="pgc1">
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/scale-check.svg'} alt="checkmark" />
                                        <p>Everything in <strong className="grow">ChartHop Grow</strong></p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/scale-check.svg'} alt="checkmark" />
                                        <p>Performance Reviews</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/scale-check.svg'} alt="checkmark" />
                                        <p>Headcount Planning</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/scale-check.svg'}alt="checkmark" />
                                        <p>ATS Integration</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/scale-check.svg'}alt="checkmark" />
                                        <p>Custom Exports** (PPT, Comp Letters, etc.)</p>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        {/*button section*/}
                        <a className="button button-withCharthop button-scale" id="charthop-scale-btn" rel="noopener noreferrer" onClick={() => showModal({buttonText:"SCALE WITH US",buttonColor:"#006699",source:"pricing-scale-chatwithus"})}>SCALE WITH US</a>
                    </div>

                    {/* ENTERPRISE MOBILE */}
                    <div className="container">
                        {/*header*/}
                        <h4 className="enterprise">ChartHop Enterprise</h4>
                        <p className="description">Provide the data and process your teams need to be more agile and efficient.</p>
                        <div className="first-section">
                            <p className="custom-pricing">Custom pricing</p>
                        </div>
                        <hr></hr>
                        {/*bullets*/}
                        <div className="content">
                            <div className="pgc1">
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/enterprise-check.svg'} alt="checkmark" />
                                        <p>Everything in <strong className="scale">ChartHop Scale</strong></p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/enterprise-check.svg'} alt="checkmark" />
                                        <p>Personalized Support</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/enterprise-check.svg'} alt="checkmark" />
                                        <p>Custom Integrations</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/enterprise-check.svg'} alt="checkmark" />
                                        <p>Workflow consulting & definition</p>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        {/*button section*/}
                        <a className="button button-withCharthop button-enterprise" id="charthop-enterprise-btn" rel="noopener noreferrer" onClick={() => showModal({buttonText:"CONTACT US",buttonColor:"#295277",source:"pricing-enterprise-chatwithus"})}>CONTACT US</a>
                    </div>

                    {/* PLUS MOBILE */}
                    <div className="container lastSection">
                        {/*header*/}
                        <h4 className="performance">Compensation Reviews</h4>                        
                        <div className="first-section">
                            <p className="price performance">+$2</p>
                            <p className="disclamer">per employee* per month<br></br>((billed annually) + additional service fees</p>
                        </div>
                        <hr></hr>
                        {/*bullets*/}
                        <div className="content performance-bullets-mobile">
                            <div className="pgc1">
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img className="check-margin" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                        <p>Consolidated data</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img  className="check-margin" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                        <p>Streamlined distribution</p>
                                    </div>
                                </div>
                                <div className="pgc2">
                                    <div className="pgc3">
                                        <img  className="check-margin" src={'/pricing/checks/build-check.svg'} alt="checkmark" />
                                        <p>Robust analytics</p>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        {/*button section*/}
                        <a className="button button-withCharthop button-build" id="performance-management-btn" rel="noopener noreferrer" onClick={() => showModal({buttonText:"CONTACT US",buttonColor:"#36ACE0",source:"pricing-performance-chatwithus"})} >CONTACT US</a>   
                    </div>
                    <div className="extra-feature-text">
                        <span>*for every employee in your organization, annual agreements start at $9,600</span>
                    </div>
                    <div className="extra-feature-text">
                      <span>**custom branded exports available for an additional fee</span>
                    </div>
                </div>
                
            </section>

            {/* COSTUMER */}
			<section className="customer  pt-8 pb-5">
				<JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
			</section >

			{/* TESTIMONIAL */}
            <section className="text-left flex-centeredColumn sectionSpacing  pt-0 pb-8" id="Customer Stories">            
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer backgroundGradientContainer">
					<div> 
						<UserTestimonyCard
							testimony={<p>
								“ChartHop is the perfect product in a world where <strong>remote</strong> work is the standard, where building <strong>diverse</strong> teams is critical and being <strong>agile</strong> as a business is the only way to <strong>thrive</strong>.”
								</p>}
							logo="/home/brand_logos/bettercloud-logo.svg"
							name="David Politis"
							readMoreButton={false}
							readMoreLink=""
							readMoreText="case studies"
							position="CEO @ BetterCloud"
							image="/home/quotes/DavidPolitis_BetterCloud.jpeg"
						/> 
					</div>
				</div> 
            </section>

            {/* YOUR DATA */}
            <section className="yourData sectionSpacing backgroundGradientContainer">
				<div className="container  ">
					<div className="row align-items-center">

						<div className="col-md-8 col-lg-6 offset-lg-1 ">
							<h2 className="mb-2 stillH1">Your data is safe with us.</h2>
							<p>You're entrusting ChartHop with your most valuable data, and we take this responsibility very seriously.</p>
							<div className="text-center d-block d-md-none d-block mr-auto ml-auto mt-4 mb-4">
								<img src='/home/safety.svg' alt="Safety" className="" width="195" />
							</div>
							<div className="container d-sm-flex">
								<ul className="col-md-6 pb-0 pr-3">
									<li>Complete SOC 2 Type 2 Examination</li>
									<li>Encryption at rest & in transit</li>
									<li>Biometric and physical-key two-factor access control</li>
								</ul>

								<ul className="col-md-6 pt-0 pr-3">
									<li>Mandatory SSO enforcement</li>
									<li>Employee auto-offboarding</li>
									<li>Customizable permission controls</li>
								</ul>
							</div>
						</div>

						<div className="reactPlayerContainer col-md-4 col-lg-3 offset-lg-1" >
							<img src='/home/safety.svg' alt="Safety" className="p-2 d-none d-md-block " />
						</div>
					</div>
				</div>
			</section>
      

            {/* LONG FORM */}

            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={HtmlParser("pricing-demo-bottom")} headertext={HtmlParser("<h2> See what everyone's talking about.</h2><h2>Let's chat!</h2>")}/>
            </section>
        </Layout>
    );
};


export default Pricing;
